/**
 * Kendte highlight-punkter i ServicePro.
 * Redaktøren skriver nøglen i feltet "Nøgle" (featureHighlightNoegle) på en Umbraco-blok.
 */
export const FEATURE_HIGHLIGHT_KEYS = ["highlight_Info", "highlight_Feedback", "highlight_Oversigtskort"] as const;

export type FeatureHighlightKey = (typeof FEATURE_HIGHLIGHT_KEYS)[number];

export type FeatureHighlightParent = "top-nav-burger";

/** Forælder lyser også (uden at blive dismissed), så brugeren finder vej til punktet. */
export const FEATURE_HIGHLIGHT_PARENT: Readonly<Partial<Record<FeatureHighlightKey, FeatureHighlightParent>>> = {
    highlight_Info: "top-nav-burger",
    highlight_Feedback: "top-nav-burger"
};

export interface FeatureHighlight {
    /** Umbraco block-nøgle — stabil ved tekstrettelser. Ny blok = vises igen. */
    id: string;
    noegle: FeatureHighlightKey;
    tekst: string;
    /** Highlightet vises ikke fra og med dette tidspunkt. `null` = ingen udløb. */
    udloeb: Date | null;
}

export const FEATURE_HIGHLIGHT_STORAGE_KEY = "servicepro-feature-spotlight-dismissed";

/** Uafhængig af store/små bogstaver og omgivende mellemrum, da nøglen tastes i Umbraco. */
export function toFeatureHighlightKey(value: unknown): FeatureHighlightKey | null {
    if (typeof value !== "string") {
        return null;
    }
    const normalized = value.trim().toLowerCase();
    return FEATURE_HIGHLIGHT_KEYS.find((key) => key.toLowerCase() === normalized) ?? null;
}
